export default class ProfileMemberType {
  abbr: string;
  singular: string;
  plural: string;

  constructor() {
    this.abbr = '';
    this.plural = '';
    this.singular = '';
  }

  static mappingObject(_obj: Record<string, string>) {
    const obj = new ProfileMemberType();
    obj.abbr = _obj.Abbr;
    obj.plural = _obj.Plural;
    obj.singular = _obj.Singular;

    return obj;
  }
}
